// AUTO-GENERATED SQL Builder (V40 Final) for Vendor
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class VendorSql {
  private ast = new SqlAst('Vendor', 'vendor');
  public readonly main: any = {};

  public guid: SqlField;
  public name: SqlField;
  public code: SqlField;
  public serviceCategoryId: SqlField;
  public stateId: SqlField;
  public cityId: SqlField;
  public addressLine: SqlField;
  public gpsLat: SqlField;
  public gpsLng: SqlField;
  public about: SqlField;
  public eventsHandled: SqlField;
  public isReseller: SqlField;
  public isVerified: SqlField;
  public ssmNo: SqlField;
  public bankId: SqlField;
  public bankAccountName: SqlField;
  public bankAccountNo: SqlField;
  public status: SqlField;
  public phone: SqlField;
  public feeRate: SqlField;
  public defaultDepositPct: SqlField;
  public suspendReason: SqlField;
  public email: SqlField;
  public logoUrl: SqlField;
  public bannerUrl: SqlField;
  public notifBooking: SqlField;
  public notifPartner: SqlField;
  public notifHold: SqlField;
  public notifPayout: SqlField;
  public isApproved: SqlField;
  public reuploadToken: SqlField;
  public reuploadTokenExpiry: SqlField;
  public bank: SqlNavHybrid;
  public city: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public serviceCategory: SqlNavHybrid;
  public state: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public blacklistList: SqlNavHybrid;
  public bookingList: SqlNavHybrid;
  public bookingFeeRateList: SqlNavHybrid;
  public bookingPackageList: SqlNavHybrid;
  public bookingPartnerChangeByFromVendorList: SqlNavHybrid;
  public bookingPartnerChangeByToVendorList: SqlNavHybrid;
  public earlyReleaseList: SqlNavHybrid;
  public ledgerEntryList: SqlNavHybrid;
  public notificationList: SqlNavHybrid;
  public offeringList: SqlNavHybrid;
  public partnerApprovalList: SqlNavHybrid;
  public partnershipByPartnerVendorList: SqlNavHybrid;
  public partnershipByResellerVendorList: SqlNavHybrid;
  public resaleList: SqlNavHybrid;
  public resaleTermByPartnerVendorList: SqlNavHybrid;
  public resaleTermByResellerVendorList: SqlNavHybrid;
  public reviewList: SqlNavHybrid;
  public vendorCoverageAreaList: SqlNavHybrid;
  public vendorUserList: SqlNavHybrid;
  public vendorVerificationList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('vendor', 'guid', '', 'id', 'vendor_guid');
    this.name = new SqlField('vendor', 'name', '', 'id', 'vendor_name');
    this.code = new SqlField('vendor', 'code', '', 'id', 'vendor_code');
    this.serviceCategoryId = new SqlField('vendor', 'serviceCategoryId', 'serviceCategory', 'id', 'vendor_serviceCategory');
    this.stateId = new SqlField('vendor', 'stateId', 'state', 'id', 'vendor_state');
    this.cityId = new SqlField('vendor', 'cityId', 'city', 'id', 'vendor_city');
    this.addressLine = new SqlField('vendor', 'addressLine', '', 'id', 'vendor_addressLine');
    this.gpsLat = new SqlField('vendor', 'gpsLat', '', 'id', 'vendor_gpsLat');
    this.gpsLng = new SqlField('vendor', 'gpsLng', '', 'id', 'vendor_gpsLng');
    this.about = new SqlField('vendor', 'about', '', 'id', 'vendor_about');
    this.eventsHandled = new SqlField('vendor', 'eventsHandled', '', 'id', 'vendor_eventsHandled');
    this.isReseller = new SqlField('vendor', 'isReseller', '', 'id', 'vendor_isReseller');
    this.isVerified = new SqlField('vendor', 'isVerified', '', 'id', 'vendor_isVerified');
    this.ssmNo = new SqlField('vendor', 'ssmNo', '', 'id', 'vendor_ssmNo');
    this.bankId = new SqlField('vendor', 'bankId', 'bank', 'id', 'vendor_bank');
    this.bankAccountName = new SqlField('vendor', 'bankAccountName', '', 'id', 'vendor_bankAccountName');
    this.bankAccountNo = new SqlField('vendor', 'bankAccountNo', '', 'id', 'vendor_bankAccountNo');
    this.status = new SqlField('vendor', 'status', '', 'id', 'vendor_status');
    this.phone = new SqlField('vendor', 'phone', '', 'id', 'vendor_phone');
    this.feeRate = new SqlField('vendor', 'feeRate', '', 'id', 'vendor_feeRate');
    this.defaultDepositPct = new SqlField('vendor', 'defaultDepositPct', '', 'id', 'vendor_defaultDepositPct');
    this.suspendReason = new SqlField('vendor', 'suspendReason', '', 'id', 'vendor_suspendReason');
    this.email = new SqlField('vendor', 'email', '', 'id', 'vendor_email');
    this.logoUrl = new SqlField('vendor', 'logoUrl', '', 'id', 'vendor_logoUrl');
    this.bannerUrl = new SqlField('vendor', 'bannerUrl', '', 'id', 'vendor_bannerUrl');
    this.notifBooking = new SqlField('vendor', 'notifBooking', '', 'id', 'vendor_notifBooking');
    this.notifPartner = new SqlField('vendor', 'notifPartner', '', 'id', 'vendor_notifPartner');
    this.notifHold = new SqlField('vendor', 'notifHold', '', 'id', 'vendor_notifHold');
    this.notifPayout = new SqlField('vendor', 'notifPayout', '', 'id', 'vendor_notifPayout');
    this.isApproved = new SqlField('vendor', 'isApproved', '', 'id', 'vendor_isApproved');
    this.reuploadToken = new SqlField('vendor', 'reuploadToken', '', 'id', 'vendor_reuploadToken');
    this.reuploadTokenExpiry = new SqlField('vendor', 'reuploadTokenExpiry', '', 'id', 'vendor_reuploadTokenExpiry');
    this.bank = createNavHybrid('vendor', 'vendor_bank', 'Bank');
    this.city = createNavHybrid('vendor', 'vendor_city', 'City');
    this.createdByUser = createNavHybrid('vendor', 'vendor_createdByUser', 'User');
    this.serviceCategory = createNavHybrid('vendor', 'vendor_serviceCategory', 'ServiceCategory');
    this.state = createNavHybrid('vendor', 'vendor_state', 'State');
    this.updatedByUser = createNavHybrid('vendor', 'vendor_updatedByUser', 'User');
    this.blacklistList = createNavHybrid('vendor', 'vendor_blacklistList', 'Blacklist');
    this.bookingList = createNavHybrid('vendor', 'vendor_bookingList', 'Booking');
    this.bookingFeeRateList = createNavHybrid('vendor', 'vendor_bookingFeeRateList', 'BookingFeeRate');
    this.bookingPackageList = createNavHybrid('vendor', 'vendor_bookingPackageList', 'BookingPackage');
    this.bookingPartnerChangeByFromVendorList = createNavHybrid('vendor', 'vendor_bookingPartnerChangeByFromVendorList', 'BookingPartnerChange');
    this.bookingPartnerChangeByToVendorList = createNavHybrid('vendor', 'vendor_bookingPartnerChangeByToVendorList', 'BookingPartnerChange');
    this.earlyReleaseList = createNavHybrid('vendor', 'vendor_earlyReleaseList', 'EarlyRelease');
    this.ledgerEntryList = createNavHybrid('vendor', 'vendor_ledgerEntryList', 'LedgerEntry');
    this.notificationList = createNavHybrid('vendor', 'vendor_notificationList', 'Notification');
    this.offeringList = createNavHybrid('vendor', 'vendor_offeringList', 'Offering');
    this.partnerApprovalList = createNavHybrid('vendor', 'vendor_partnerApprovalList', 'PartnerApproval');
    this.partnershipByPartnerVendorList = createNavHybrid('vendor', 'vendor_partnershipByPartnerVendorList', 'Partnership');
    this.partnershipByResellerVendorList = createNavHybrid('vendor', 'vendor_partnershipByResellerVendorList', 'Partnership');
    this.resaleList = createNavHybrid('vendor', 'vendor_resaleList', 'Resale');
    this.resaleTermByPartnerVendorList = createNavHybrid('vendor', 'vendor_resaleTermByPartnerVendorList', 'ResaleTerm');
    this.resaleTermByResellerVendorList = createNavHybrid('vendor', 'vendor_resaleTermByResellerVendorList', 'ResaleTerm');
    this.reviewList = createNavHybrid('vendor', 'vendor_reviewList', 'Review');
    this.vendorCoverageAreaList = createNavHybrid('vendor', 'vendor_vendorCoverageAreaList', 'VendorCoverageArea');
    this.vendorUserList = createNavHybrid('vendor', 'vendor_vendorUserList', 'VendorUser');
    this.vendorVerificationList = createNavHybrid('vendor', 'vendor_vendorVerificationList', 'VendorVerification');
    this.id = new SqlField('vendor', 'id', '', 'id', 'vendor_id');
    this.isDeleted = new SqlField('vendor', 'isDeleted', '', 'id', 'vendor_isDeleted');
    this.createdBy = new SqlField('vendor', 'createdBy', '', 'id', 'vendor_createdBy');
    this.createdDate = new SqlField('vendor', 'createdDate', '', 'id', 'vendor_createdDate');
    this.updatedBy = new SqlField('vendor', 'updatedBy', '', 'id', 'vendor_updatedBy');
    this.updatedDate = new SqlField('vendor', 'updatedDate', '', 'id', 'vendor_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:VendorSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:VendorSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:VendorSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:VendorSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:VendorSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:VendorSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:VendorSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:VendorSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:VendorSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:VendorSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
